import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Formik, ErrorMessage } from 'formik'
import * as yup from 'yup'
import { Button, TextInput } from 'components/shard'
import Alert from 'components/Alert'
import { Color, Size } from 'const'
import { Modal } from '../../../common/Modal'
import _ from 'lodash'

import { useIdHook } from 'hooks'

function Switch() {
  const [values, setValues] = useState({})
  const { resultDisplay, setResultDisplay, isLoading, errors, setErrors, history, execUpdateTanakaId } = useIdHook()

  useEffect(() => {
    if (_.isEmpty(values)) {
      return
    }

    execUpdateTanakaId(values.email)
  }, [execUpdateTanakaId, values])

  return (
    <Wrapper>
      {errors.length > 0 && (
        <Alert type="error" message="エラー" description={errors.join('\n')} onClose={() => setErrors([])} />
      )}
      <Modal
        title="ID変更は完了していません"
        text="変更後のメールアドレスに送られたURLをクリック後、IDの変更が完了します。"
        caution="※URL有効期限は3日となります。3日経過後は再度変更手続きをお願いします。"
        display={resultDisplay}
        overlayOnClick={() => setResultDisplay(false)}
        buttonOnClick={() => history.push('/login')}
      />
      <Formik
        initialValues={{
          email: '',
          re_email: '',
        }}
        onSubmit={(values, actions) => {
          setValues(values)
        }}
        validationSchema={yup.object().shape({
          email: yup.string().required('項目が未入力です'),
          re_email: yup.string().test('email-match', 'TANAKA-ID (メールアドレス)が一致していません', function(value) {
            const { email } = this.parent

            return email === value
          }),
        })}
      >
        {({ values, handleChange, handleBlur, handleSubmit, dirty, isValid }) => (
          <form
            onSubmit={(e) => {
              handleSubmit(e)
              e.preventDefault() // useEffectでstateを更新するためにcomponentの自動更新を防ぐ
            }}
          >
            <IdBlock>
              <Caution>
                NNALシステム移管に伴い、IDの再登録をお願いしております。お客様にはご不便をおかけしますが、連絡可能なメールアドレスをIDとしてご登録ください。
              </Caution>
              <InputLabel>TANAKA-ID (メールアドレス)</InputLabel>
              <InputArea>
                <TextInputArea>
                  <TextInput
                    type="text"
                    name="email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                    ariaLabel="email"
                    placeholder="example@google.com"
                    errorMessage={<ErrorMessage name="email" />}
                  />
                </TextInputArea>
              </InputArea>
              <InputLabel>確認のため、もう一度入力してください</InputLabel>
              <InputArea>
                <TextInputArea>
                  <TextInput
                    type="text"
                    name="re_email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.re_email}
                    ariaLabel="re_email"
                    placeholder="example@google.com(確認)"
                    errorMessage={<ErrorMessage name="re_email" />}
                  />
                </TextInputArea>
              </InputArea>
            </IdBlock>
            <Separator />
            <ButtonWrapper>
              <Button type={'submit'} primary disabled={!isValid || !dirty || isLoading}>
                変更する
              </Button>
            </ButtonWrapper>
          </form>
        )}
      </Formik>
    </Wrapper>
  )
}

const Wrapper = styled.div``
const IdBlock = styled.div`
  padding: 0 20px 20px 20px;
`
const Caution = styled.div`
  padding-top: 20px;
`
const InputLabel = styled.div`
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.INPUT_LABEL};
  padding-top: 22px;
`
const InputArea = styled.div``
const TextInputArea = styled.div``
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px 0;
`
const Separator = styled.hr`
  border-top: 1px solid ${Color.LINE.NORMAL};
  border-bottom: 0;
  margin: 0;
`

export default Switch
